var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGotr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 90 90",
    transform: "matrix(.69 0 0 .69 15.5 15.5)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.59 22.59S2.38 16.52 2.38 44.26c0 0-.11 6.23 4.14 14.24A24.83 24.83 0 0 1 9 73.48L7.71 83C7 86.22 9 88.08 11 88.08c0 0 13.83 1.09 13.83-1.28 0-2.71-3.72-3.37-3.72-3.37a4.15 4.15 0 0 1-1-4.85 38.57 38.57 0 0 1 2.66-4.75c1.78-2.73 4.2-8.83 5-10.9a.74.74 0 0 1 .91-.47c2.67.77 13.11 2.76 28.22-7.07a1 1 0 0 1 1.49.88c-.56 4.37-1.34 14.78 2.25 23.88a.29.29 0 0 1-.41.38c-1.28-.72-3.72-1.62-3.63 1.93 0 0-.62 6.93 11 5.62 0 0 3.87-.73 2.23-7.55 0 0 5.38-36.27 4.65-44.34A1.18 1.18 0 0 1 76 35c2.45.87 6.68 1.68 8.94-1.86 0 0 2.89-3.88 2.89-6.42l-3.03-5.36 1.87-2.77s-3.85-5.66-3.73-7.89c0 0-2.29-8.07-8.25-8.37 0 0-4.27-.42-10.11 5.48-.01.01-15.32 18.73-36.99 14.78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotr);
export default __webpack_public_path__ + "static/media/GOTR.ff80fef5df19f8cf5a520244a5343d67.svg";
export { ForwardRef as ReactComponent };